import { render, staticRenderFns } from "./logDetails.vue?vue&type=template&id=52b75f61&scoped=true&"
import script from "./logDetails.vue?vue&type=script&lang=js&"
export * from "./logDetails.vue?vue&type=script&lang=js&"
import style0 from "./logDetails.vue?vue&type=style&index=0&id=52b75f61&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b75f61",
  null
  
)

export default component.exports